import {Component, OnInit, ViewChild} from '@angular/core';
import {Menu} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import {Router} from '@angular/router';
import {AdminControlService} from "../../@shared/services/admin-control.service";
import {CacheService} from "../../@shared/services/cache.service";

@Component({
    selector: 'app-roles-management',
    templateUrl: './roles-management.component.html',
    styleUrls: ['./roles-management.component.scss']
})
export class RolesManagementComponent implements OnInit {
    @ViewChild('menu') menuItem: Menu;
    actionMenu: MenuItem[];
    roles: any;
    selectedRole: any;
    isLoading = false;
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');

    constructor(private adminRoute: AdminControlService, private router: Router, private cacheService: CacheService) {
    }

    ngOnInit(): void {
        this.getRoles(0, 10);
        this.actionMenu = [
            {
                label: 'Edit Modules',
                command: () => {
                    this.onClickNavigateToUpdateRole();
                }
            }
        ];
    }

    getRoles(page = 0, size = 10) {
        this.isLoading = true;
        this.adminRoute.getPagedRoles(page, size)
            .subscribe((res) => {
                this.isLoading = false;
                console.log(res);
                this.roles = res;
            }, error => {
                this.isLoading = false;
                console.log(error);
            });
    }

    handleToggle(event: Event, role) {
        this.selectedRole = role;
        this.menuItem.toggle(event);
    }

    onClickNavigateToUpdateRole(action?: any) {
        console.log(this.selectedRole, action, ' action');
        if (action === 'new') {
            this.router.navigate(['update-role'], {queryParams: {roleId: ''}});
        } else {
            this.router.navigate(['update-role'], {queryParams: {roleId: this.selectedRole?.roleId}});
        }
    }

    paginateRoles(event: any) {
        this.getRoles(event?.page, 10);
    }
}
